import { TransferList } from "../../views/safeBox/transferList";
import { ProfitList } from "../../views/safeBox/profitList";

import { langPage } from "../../locales";

const lang = langPage?.settings;

export const safeBoxRouters = [
  {
    path: "/safeBox/transferList",
    name: "safeBoxTransferList",
    exact: true,
    component: TransferList,
    meta: {
      breadcrumb: [
        {
          name: "保险箱",
          path: ""
        },
        {
          name: "交易列表",
          path: ""
        }
      ],
      privilegeCode: "safeBoxTransferList",
    }
  },
  {
    path: "/safeBox/profitList",
    name: "safeBoxProfitList",
    exact: true,
    component: ProfitList,
    meta: {
      breadcrumb: [
        {
          name: "保险箱",
          path: ""
        },
        {
          name: "收益列表",
          path: ""
        }
      ],
      privilegeCode: "safeBoxProfitList",
    }
  },
];
